<template>
  <div class="con_page">
    <div style="font-size: 14px;
    line-height: 34px;
    text-align: left;padding: 10px;" v-html="materialData.materialContent"></div>
  </div>
</template>
<style lang="scss" scoped>
.con_page {

}
</style>
<script>
export default {
  data() {
    return {
      materialData: ''
    }
  },
  methods: {
    // jssdk
    fetchJsSdkSign() {
        const url = encodeURIComponent(location.href.split('#')[0])
        // alert('获取签名url ->' + url)
        api.getJsJdkSign({
          url
        }).then(async (data) => {
          const { appId, jssdkReqData } = data.data
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ['hideOptionMenu', 'showOptionMenu']
          }
          const { wxHideMenu } = await this.$wx.wxConfig(options)
          wxHideMenu()
        })
      }
  },
  created() {
    this.materialData = JSON.parse(localStorage.getItem('materialData'))
    this.fetchJsSdkSign()
  }
}
</script>


